import { Survey, SurveyQuestion } from 'types/survey';
import { TranslationsKeys, useTranslate } from 'hooks/useTranslate';
import { useSurveyTranslation } from 'hooks/useSurveyTranslation';

export const useSurveyQuestion = (surveyDefinition: Survey) => {
  const { t } = useTranslate();
  const ts = useSurveyTranslation(surveyDefinition);

  const getSurveyQuestionDescription = (question: SurveyQuestion) => {
    const isNumericInputQuestion = question.type === 'numeric' && question.input === 'counter';

    // If there isn't a description coming through from the definition,
    // and the question is a numeric input (units, or missing the input type [e.g. revenue]),
    // we need to add a generic helper description to guide the user in how the amount should be entered.

    const description =
      isNumericInputQuestion && !question.description
        ? t(TranslationsKeys.surveySectionPage_numericInputDescription)
        : ts(question.description);

    return description;
  };

  return { getSurveyQuestionDescription };
};
